import {
  PaginatedProductServices,
  ProductService,
  ProductServiceInput
} from 'types/BillingTypes';
import useHttp from '../helpers/HttpMethods';

const http = useHttp();

class ProductServiceService {
  /**
   * Lista todos os produtos/serviços paginados.
   * @param {string} filter - Filtros em string.
   * @returns {Promise<PaginatedProductServices | Response>} - Produtos/Serviços em formato paginado.
   */
  static async list(filter: string): Promise<PaginatedProductServices | Response> {
    return await http.get(`/products-services?${filter}`);
  }

  /**
   * Busca um produto/serviço por ID.
   * @param {number} id - ID do produto/serviço.
   * @returns {Promise<ProductService | Response>} - Dados completos do produto/serviço.
   */
  static async findById(id: number): Promise<ProductService | Response> {
    return await http.get(`/products-services/${id}`);
  }

  /**
   * Cria um novo produto/serviço.
   * @param {ProductServiceInput} body - Dados do produto/serviço a ser criado.
   * @returns {Promise<ProductService | Response>} - Produto/Serviço criado ou resposta de erro.
   */
  static async create(body: ProductServiceInput): Promise<ProductService | Response> {
    return await http.post(body, '/products-services');
  }

  /**
   * Edita um produto/serviço existente.
   * @param {number} id - ID do produto/serviço a ser atualizado.
   * @param {ProductServiceInput} body - Dados do produto/serviço para atualização.
   * @returns {Promise<ProductService | Response>} - Produto/Serviço atualizado ou resposta de erro.
   */
  static async edit(
    id: number,
    body: ProductServiceInput
  ): Promise<ProductService | Response> {
    return await http.put(body, `/products-services/${id}`);
  }

  /**
   * Remove um produto/serviço.
   * @param {number} id - ID do produto/serviço.
   * @returns {Promise<Response>} - Retorno padrão de uma request.
   */
  static async delete(id: number): Promise<Response> {
    return await http.del(`/products-services/${id}`);
  }
}

export default ProductServiceService;

